var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel__phrase-wrapper"},_vm._l((_vm.words),function(word,index){return _c('span',{key:index,staticClass:"panel__partial-phrase"},[(word.isMisspelled)?[_c('span',{staticClass:"misspelled-word"},[_vm._v(_vm._s(word.text))])]:_c('span',[_vm._v(_vm._s(word.text))])],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }